// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CalCupRouteImport } from './routes/cal-cup'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as HealthRouteImport } from './routes/health'
import { Route as LogInRouteImport } from './routes/log-in'
import { Route as LogOutRouteImport } from './routes/log-out'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrizePoolRouteImport } from './routes/prize-pool'
import { Route as RatingsRouteImport } from './routes/ratings'
import { Route as SanctioningRouteImport } from './routes/sanctioning'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountChangePasswordRouteImport } from './routes/account/change-password'
import { Route as AccountRecoverRouteImport } from './routes/account/recover'
import { Route as AccountResetPasswordRouteImport } from './routes/account/reset-password'
import { Route as AccountSetupRouteImport } from './routes/account/setup'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminConstantContactRouteImport } from './routes/admin/constant-contact'
import { Route as AdminInvoicesRouteImport } from './routes/admin/invoices'
import { Route as AdminProfilesRouteImport } from './routes/admin/profiles'
import { Route as AdminReconcileProfilesRouteImport } from './routes/admin/reconcile-profiles'
import { Route as AdminScheduleRouteImport } from './routes/admin/schedule'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminSystemTasksRouteImport } from './routes/admin/system-tasks'
import { Route as AdminVenuesRouteImport } from './routes/admin/venues'
import { Route as CheckInCheckInCodeRouteImport } from './routes/check-in.$checkInCode'
import { Route as FaqsChar123SubjectChar125RouteImport } from './routes/faqs.{-$subject}'
import { Route as InfoCedarsRouteImport } from './routes/info/cedars'
import { Route as JuniorsIndexRouteImport } from './routes/juniors/index'
import { Route as JuniorsCalCupRouteImport } from './routes/juniors/cal-cup'
import { Route as LeaderboardChar123GenderChar125RouteImport } from './routes/leaderboard.{-$gender}'
import { Route as PIndexRouteImport } from './routes/p.index'
import { Route as PUsernameRouteImport } from './routes/p.$username'
import { Route as TdIndexRouteImport } from './routes/td/index'
import { Route as TdPlayersRouteImport } from './routes/td/players'
import { Route as TdVenuesRouteImport } from './routes/td/venues'
import { Route as TournamentsIndexRouteImport } from './routes/tournaments/index'
import { Route as TournamentsCreateRouteImport } from './routes/tournaments/create'
import { Route as TournamentsFaqsRouteImport } from './routes/tournaments/faqs'
import { Route as TshirtPickupMembershipIdRouteImport } from './routes/tshirt-pickup.$membershipId'
import { Route as VenuesVenueIdRouteImport } from './routes/venues/$venueId'
import { Route as AccountForgotPasswordIndexRouteImport } from './routes/account/forgot-password/index'
import { Route as AccountForgotPasswordEmailRouteImport } from './routes/account/forgot-password/email'
import { Route as AccountForgotPasswordPhoneRouteImport } from './routes/account/forgot-password/phone'
import { Route as AccountRegistrationsIndexRouteImport } from './routes/account/registrations/index'
import { Route as AccountRegistrationsCheckoutRouteImport } from './routes/account/registrations/checkout'
import { Route as AccountRegistrationsSuccessRouteImport } from './routes/account/registrations/success'
import { Route as AccountVerifyIndexRouteImport } from './routes/account/verify/index'
import { Route as AccountVerifySuccessRouteImport } from './routes/account/verify/success'
import { Route as AdminReportsDivisionsRouteImport } from './routes/admin/reports/divisions'
import { Route as AdminReportsTshirtsRouteImport } from './routes/admin/reports/tshirts'
import { Route as AdminUserUserIdRouteImport } from './routes/admin/user.$userId'
import { Route as JuniorsLeaderboardChar123GenderChar125RouteImport } from './routes/juniors/leaderboard.{-$gender}'
import { Route as ProfileProfileIdIndexRouteImport } from './routes/profile/$profileId/index'
import { Route as ProfileProfileIdEditRouteImport } from './routes/profile/$profileId/edit'
import { Route as TdHelpIndexRouteImport } from './routes/td/help/index'
import { Route as TdHelpSlugRouteImport } from './routes/td/help/$slug'
import { Route as TournamentsTournamentIdIndexRouteImport } from './routes/tournaments/$tournamentId/index'
import { Route as TournamentsTournamentIdEditRouteImport } from './routes/tournaments/$tournamentId/edit'
import { Route as TournamentsDivisionsDivisionIdRouteImport } from './routes/tournaments/divisions/$divisionId'
import { Route as AccountRegistrationsCompletePaymentIntentIdRouteImport } from './routes/account/registrations/complete.$paymentIntentId'
import { Route as MatchesPlayoffMatchIdIndexRouteImport } from './routes/matches/playoff/$matchId/index'
import { Route as MatchesPoolMatchIdIndexRouteImport } from './routes/matches/pool/$matchId/index'
import { Route as TournamentsTournamentIdDivisionIdChar123TabChar125RouteImport } from './routes/tournaments/$tournamentId/$divisionId.{-$tab}'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CalCupRoute = CalCupRouteImport.update({
            id: '/cal-cup',path: '/cal-cup',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const LogInRoute = LogInRouteImport.update({
            id: '/log-in',path: '/log-in',getParentRoute: () => rootRouteImport
          })
const LogOutRoute = LogOutRouteImport.update({
            id: '/log-out',path: '/log-out',getParentRoute: () => rootRouteImport
          })
const NotFoundRoute = NotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PrizePoolRoute = PrizePoolRouteImport.update({
            id: '/prize-pool',path: '/prize-pool',getParentRoute: () => rootRouteImport
          })
const RatingsRoute = RatingsRouteImport.update({
            id: '/ratings',path: '/ratings',getParentRoute: () => rootRouteImport
          })
const SanctioningRoute = SanctioningRouteImport.update({
            id: '/sanctioning',path: '/sanctioning',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const AccountChangePasswordRoute = AccountChangePasswordRouteImport.update({
            id: '/account/change-password',path: '/account/change-password',getParentRoute: () => rootRouteImport
          })
const AccountRecoverRoute = AccountRecoverRouteImport.update({
            id: '/account/recover',path: '/account/recover',getParentRoute: () => rootRouteImport
          })
const AccountResetPasswordRoute = AccountResetPasswordRouteImport.update({
            id: '/account/reset-password',path: '/account/reset-password',getParentRoute: () => rootRouteImport
          })
const AccountSetupRoute = AccountSetupRouteImport.update({
            id: '/account/setup',path: '/account/setup',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminConstantContactRoute = AdminConstantContactRouteImport.update({
            id: '/admin/constant-contact',path: '/admin/constant-contact',getParentRoute: () => rootRouteImport
          })
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
            id: '/admin/invoices',path: '/admin/invoices',getParentRoute: () => rootRouteImport
          })
const AdminProfilesRoute = AdminProfilesRouteImport.update({
            id: '/admin/profiles',path: '/admin/profiles',getParentRoute: () => rootRouteImport
          })
const AdminReconcileProfilesRoute = AdminReconcileProfilesRouteImport.update({
            id: '/admin/reconcile-profiles',path: '/admin/reconcile-profiles',getParentRoute: () => rootRouteImport
          })
const AdminScheduleRoute = AdminScheduleRouteImport.update({
            id: '/admin/schedule',path: '/admin/schedule',getParentRoute: () => rootRouteImport
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => rootRouteImport
          })
const AdminSystemTasksRoute = AdminSystemTasksRouteImport.update({
            id: '/admin/system-tasks',path: '/admin/system-tasks',getParentRoute: () => rootRouteImport
          })
const AdminVenuesRoute = AdminVenuesRouteImport.update({
            id: '/admin/venues',path: '/admin/venues',getParentRoute: () => rootRouteImport
          })
const CheckInCheckInCodeRoute = CheckInCheckInCodeRouteImport.update({
            id: '/check-in/$checkInCode',path: '/check-in/$checkInCode',getParentRoute: () => rootRouteImport
          })
const FaqsChar123SubjectChar125Route = FaqsChar123SubjectChar125RouteImport.update({
            id: '/faqs/{-$subject}',path: '/faqs/{-$subject}',getParentRoute: () => rootRouteImport
          })
const InfoCedarsRoute = InfoCedarsRouteImport.update({
            id: '/info/cedars',path: '/info/cedars',getParentRoute: () => rootRouteImport
          })
const JuniorsIndexRoute = JuniorsIndexRouteImport.update({
            id: '/juniors/',path: '/juniors/',getParentRoute: () => rootRouteImport
          })
const JuniorsCalCupRoute = JuniorsCalCupRouteImport.update({
            id: '/juniors/cal-cup',path: '/juniors/cal-cup',getParentRoute: () => rootRouteImport
          })
const LeaderboardChar123GenderChar125Route = LeaderboardChar123GenderChar125RouteImport.update({
            id: '/leaderboard/{-$gender}',path: '/leaderboard/{-$gender}',getParentRoute: () => rootRouteImport
          })
const PIndexRoute = PIndexRouteImport.update({
            id: '/p/',path: '/p/',getParentRoute: () => rootRouteImport
          })
const PUsernameRoute = PUsernameRouteImport.update({
            id: '/p/$username',path: '/p/$username',getParentRoute: () => rootRouteImport
          })
const TdIndexRoute = TdIndexRouteImport.update({
            id: '/td/',path: '/td/',getParentRoute: () => rootRouteImport
          })
const TdPlayersRoute = TdPlayersRouteImport.update({
            id: '/td/players',path: '/td/players',getParentRoute: () => rootRouteImport
          })
const TdVenuesRoute = TdVenuesRouteImport.update({
            id: '/td/venues',path: '/td/venues',getParentRoute: () => rootRouteImport
          })
const TournamentsIndexRoute = TournamentsIndexRouteImport.update({
            id: '/tournaments/',path: '/tournaments/',getParentRoute: () => rootRouteImport
          })
const TournamentsCreateRoute = TournamentsCreateRouteImport.update({
            id: '/tournaments/create',path: '/tournaments/create',getParentRoute: () => rootRouteImport
          })
const TournamentsFaqsRoute = TournamentsFaqsRouteImport.update({
            id: '/tournaments/faqs',path: '/tournaments/faqs',getParentRoute: () => rootRouteImport
          })
const TshirtPickupMembershipIdRoute = TshirtPickupMembershipIdRouteImport.update({
            id: '/tshirt-pickup/$membershipId',path: '/tshirt-pickup/$membershipId',getParentRoute: () => rootRouteImport
          })
const VenuesVenueIdRoute = VenuesVenueIdRouteImport.update({
            id: '/venues/$venueId',path: '/venues/$venueId',getParentRoute: () => rootRouteImport
          })
const AccountForgotPasswordIndexRoute = AccountForgotPasswordIndexRouteImport.update({
            id: '/account/forgot-password/',path: '/account/forgot-password/',getParentRoute: () => rootRouteImport
          })
const AccountForgotPasswordEmailRoute = AccountForgotPasswordEmailRouteImport.update({
            id: '/account/forgot-password/email',path: '/account/forgot-password/email',getParentRoute: () => rootRouteImport
          })
const AccountForgotPasswordPhoneRoute = AccountForgotPasswordPhoneRouteImport.update({
            id: '/account/forgot-password/phone',path: '/account/forgot-password/phone',getParentRoute: () => rootRouteImport
          })
const AccountRegistrationsIndexRoute = AccountRegistrationsIndexRouteImport.update({
            id: '/account/registrations/',path: '/account/registrations/',getParentRoute: () => rootRouteImport
          })
const AccountRegistrationsCheckoutRoute = AccountRegistrationsCheckoutRouteImport.update({
            id: '/account/registrations/checkout',path: '/account/registrations/checkout',getParentRoute: () => rootRouteImport
          })
const AccountRegistrationsSuccessRoute = AccountRegistrationsSuccessRouteImport.update({
            id: '/account/registrations/success',path: '/account/registrations/success',getParentRoute: () => rootRouteImport
          })
const AccountVerifyIndexRoute = AccountVerifyIndexRouteImport.update({
            id: '/account/verify/',path: '/account/verify/',getParentRoute: () => rootRouteImport
          })
const AccountVerifySuccessRoute = AccountVerifySuccessRouteImport.update({
            id: '/account/verify/success',path: '/account/verify/success',getParentRoute: () => rootRouteImport
          })
const AdminReportsDivisionsRoute = AdminReportsDivisionsRouteImport.update({
            id: '/admin/reports/divisions',path: '/admin/reports/divisions',getParentRoute: () => rootRouteImport
          })
const AdminReportsTshirtsRoute = AdminReportsTshirtsRouteImport.update({
            id: '/admin/reports/tshirts',path: '/admin/reports/tshirts',getParentRoute: () => rootRouteImport
          })
const AdminUserUserIdRoute = AdminUserUserIdRouteImport.update({
            id: '/admin/user/$userId',path: '/admin/user/$userId',getParentRoute: () => rootRouteImport
          })
const JuniorsLeaderboardChar123GenderChar125Route = JuniorsLeaderboardChar123GenderChar125RouteImport.update({
            id: '/juniors/leaderboard/{-$gender}',path: '/juniors/leaderboard/{-$gender}',getParentRoute: () => rootRouteImport
          })
const ProfileProfileIdIndexRoute = ProfileProfileIdIndexRouteImport.update({
            id: '/profile/$profileId/',path: '/profile/$profileId/',getParentRoute: () => rootRouteImport
          })
const ProfileProfileIdEditRoute = ProfileProfileIdEditRouteImport.update({
            id: '/profile/$profileId/edit',path: '/profile/$profileId/edit',getParentRoute: () => rootRouteImport
          })
const TdHelpIndexRoute = TdHelpIndexRouteImport.update({
            id: '/td/help/',path: '/td/help/',getParentRoute: () => rootRouteImport
          })
const TdHelpSlugRoute = TdHelpSlugRouteImport.update({
            id: '/td/help/$slug',path: '/td/help/$slug',getParentRoute: () => rootRouteImport
          })
const TournamentsTournamentIdIndexRoute = TournamentsTournamentIdIndexRouteImport.update({
            id: '/tournaments/$tournamentId/',path: '/tournaments/$tournamentId/',getParentRoute: () => rootRouteImport
          })
const TournamentsTournamentIdEditRoute = TournamentsTournamentIdEditRouteImport.update({
            id: '/tournaments/$tournamentId/edit',path: '/tournaments/$tournamentId/edit',getParentRoute: () => rootRouteImport
          })
const TournamentsDivisionsDivisionIdRoute = TournamentsDivisionsDivisionIdRouteImport.update({
            id: '/tournaments/divisions/$divisionId',path: '/tournaments/divisions/$divisionId',getParentRoute: () => rootRouteImport
          })
const AccountRegistrationsCompletePaymentIntentIdRoute = AccountRegistrationsCompletePaymentIntentIdRouteImport.update({
            id: '/account/registrations/complete/$paymentIntentId',path: '/account/registrations/complete/$paymentIntentId',getParentRoute: () => rootRouteImport
          })
const MatchesPlayoffMatchIdIndexRoute = MatchesPlayoffMatchIdIndexRouteImport.update({
            id: '/matches/playoff/$matchId/',path: '/matches/playoff/$matchId/',getParentRoute: () => rootRouteImport
          })
const MatchesPoolMatchIdIndexRoute = MatchesPoolMatchIdIndexRouteImport.update({
            id: '/matches/pool/$matchId/',path: '/matches/pool/$matchId/',getParentRoute: () => rootRouteImport
          })
const TournamentsTournamentIdDivisionIdChar123TabChar125Route = TournamentsTournamentIdDivisionIdChar123TabChar125RouteImport.update({
            id: '/tournaments/$tournamentId/$divisionId/{-$tab}',path: '/tournaments/$tournamentId/$divisionId/{-$tab}',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CalCupRoute: CalCupRoute,GalleryRoute: GalleryRoute,HealthRoute: HealthRoute,LogInRoute: LogInRoute,LogOutRoute: LogOutRoute,NotFoundRoute: NotFoundRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PrizePoolRoute: PrizePoolRoute,RatingsRoute: RatingsRoute,SanctioningRoute: SanctioningRoute,SearchRoute: SearchRoute,SignUpRoute: SignUpRoute,AccountChangePasswordRoute: AccountChangePasswordRoute,AccountRecoverRoute: AccountRecoverRoute,AccountResetPasswordRoute: AccountResetPasswordRoute,AccountSetupRoute: AccountSetupRoute,AdminConstantContactRoute: AdminConstantContactRoute,AdminInvoicesRoute: AdminInvoicesRoute,AdminProfilesRoute: AdminProfilesRoute,AdminReconcileProfilesRoute: AdminReconcileProfilesRoute,AdminScheduleRoute: AdminScheduleRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSystemTasksRoute: AdminSystemTasksRoute,AdminVenuesRoute: AdminVenuesRoute,CheckInCheckInCodeRoute: CheckInCheckInCodeRoute,FaqsChar123SubjectChar125Route: FaqsChar123SubjectChar125Route,InfoCedarsRoute: InfoCedarsRoute,JuniorsCalCupRoute: JuniorsCalCupRoute,LeaderboardChar123GenderChar125Route: LeaderboardChar123GenderChar125Route,PUsernameRoute: PUsernameRoute,TdPlayersRoute: TdPlayersRoute,TdVenuesRoute: TdVenuesRoute,TournamentsCreateRoute: TournamentsCreateRoute,TournamentsFaqsRoute: TournamentsFaqsRoute,TshirtPickupMembershipIdRoute: TshirtPickupMembershipIdRoute,VenuesVenueIdRoute: VenuesVenueIdRoute,AccountIndexRoute: AccountIndexRoute,AdminIndexRoute: AdminIndexRoute,JuniorsIndexRoute: JuniorsIndexRoute,PIndexRoute: PIndexRoute,TdIndexRoute: TdIndexRoute,TournamentsIndexRoute: TournamentsIndexRoute,AccountForgotPasswordEmailRoute: AccountForgotPasswordEmailRoute,AccountForgotPasswordPhoneRoute: AccountForgotPasswordPhoneRoute,AccountRegistrationsCheckoutRoute: AccountRegistrationsCheckoutRoute,AccountRegistrationsSuccessRoute: AccountRegistrationsSuccessRoute,AccountVerifySuccessRoute: AccountVerifySuccessRoute,AdminReportsDivisionsRoute: AdminReportsDivisionsRoute,AdminReportsTshirtsRoute: AdminReportsTshirtsRoute,AdminUserUserIdRoute: AdminUserUserIdRoute,JuniorsLeaderboardChar123GenderChar125Route: JuniorsLeaderboardChar123GenderChar125Route,ProfileProfileIdEditRoute: ProfileProfileIdEditRoute,TdHelpSlugRoute: TdHelpSlugRoute,TournamentsTournamentIdEditRoute: TournamentsTournamentIdEditRoute,TournamentsDivisionsDivisionIdRoute: TournamentsDivisionsDivisionIdRoute,AccountForgotPasswordIndexRoute: AccountForgotPasswordIndexRoute,AccountRegistrationsIndexRoute: AccountRegistrationsIndexRoute,AccountVerifyIndexRoute: AccountVerifyIndexRoute,ProfileProfileIdIndexRoute: ProfileProfileIdIndexRoute,TdHelpIndexRoute: TdHelpIndexRoute,TournamentsTournamentIdIndexRoute: TournamentsTournamentIdIndexRoute,AccountRegistrationsCompletePaymentIntentIdRoute: AccountRegistrationsCompletePaymentIntentIdRoute,TournamentsTournamentIdDivisionIdChar123TabChar125Route: TournamentsTournamentIdDivisionIdChar123TabChar125Route,MatchesPlayoffMatchIdIndexRoute: MatchesPlayoffMatchIdIndexRoute,MatchesPoolMatchIdIndexRoute: MatchesPoolMatchIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)